import React from "react";
import "./Footer.scss";
import { FaYoutube, FaDiscord, FaTiktok } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__column">
          <div className="footer__links">
            <a href="/">Home</a>
            <a href="#/policy">Polityka</a>
            <a href="#/tos">Warunki</a>
            <a href="https://wildlandsrp.pl/rodo.pdf">RODO</a>
          </div>
        </div>
        <div className="footer__column">
          <div className="footer__social-icons">
            <a href="https://www.youtube.com/channel/UC18QfwRztveFf_g0wBsoF_Q">
              <FaYoutube className="icon" />
            </a>
            <a href="https://www.tiktok.com/@wildlandsrppl">
              <FaTiktok className="icon" />
            </a>
            <a href="https://discord.gg/pcShtURP9V">
              <FaDiscord className="icon" />
            </a>
          </div>
        </div>
        <div className="footer__column">
          <div className="footer__copyright">
            WildLandsRP.pl © {new Date().getFullYear()} <br />
            Nie jesteśmy powiązani ani wspierani przez Rockstar North, Take-Two
            Interactive, CFX Collective ani innych posiadaczy praw.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
